<h1 class="subtitle text-left">{{ "MEMBERSHIP.DELIVERY_TITLE" | translate }}</h1>

<div class="mt-5" *ngIf="deliveryData">
  <div class="buy-membership-content">
    <form [formGroup]="deliveryForm" (ngSubmit)="onSubmit()" class="form user-form">
      <div class="delivery-content-container">
        <ng-template ngFor let-field [ngForOf]="deliveryData">
          <div class="container-checkbox">
            <label>{{ field.naziv }}  - {{ field.cijena }} €
              <input (change)="changeDeliveryWay(field.sifra, field.unosPodataka, field.inozemna)" type="radio" value="{{field.sifra}}" formControlName="deliveryWay" data-name="user-data-membership" class="form-control" placeholder=" " />
              <span class="checkmark radio"></span>
            </label>
          </div>
        </ng-template>
      </div>

      <div class="user-form-input-container" *ngIf="selectedDelivery.id !== '' && selectedDelivery.enterData">
        <div class="user-form-input" [class.invalid]="deliveryForm.get('firstName')!.touched && deliveryForm.get('firstName')!.invalid">
          <label for="firstName" class="user-form-input-label">{{ "INPUTS.NAME" | translate }} *</label>
          <input id="firstName" type="text" formControlName="firstName" placeholder=" " data-name="delivery-form" (input)="removeErrorMessage($event.target)"/>
        </div>
        <div class="user-form-input" [class.invalid]="deliveryForm.get('lastName')!.touched && deliveryForm.get('lastName')!.invalid">
          <label for="lastName" class="user-form-input-label">{{ "INPUTS.LASTNAME" | translate }} *</label>
          <input id="lastName" type="text" formControlName="lastName" placeholder=" " data-name="delivery-form" (input)="removeErrorMessage($event.target)"/>
        </div>
        <div class="user-form-input" [class.invalid]="deliveryForm.get('street')!.touched && deliveryForm.get('street')!.invalid">
          <label for="street" class="user-form-input-label">{{ "INPUT_FIELDS.STREET" | translate }} *</label>
          <input id="street" type="text" formControlName="street" placeholder=" " data-name="delivery-form" (input)="removeErrorMessage($event.target)"/>
        </div>
        <div class="user-form-input" [class.invalid]="deliveryForm.get('houseNo')!.touched && deliveryForm.get('houseNo')!.invalid">
          <label for="houseNo" class="user-form-input-label">{{ "INPUTS.HOUSE_NO" | translate }} *</label>
          <input id="houseNo" type="text" formControlName="houseNo" placeholder=" " data-name="delivery-form" (input)="removeErrorMessage($event.target)"/>
        </div>
        <div class="user-form-input" [class.invalid]="deliveryForm.get('city')!.touched && deliveryForm.get('city')!.invalid">
          <label for="city" class="user-form-input-label">{{ "INPUTS.CITY" | translate }} *</label>
          <input id="city" type="text" formControlName="city" placeholder=" " data-name="delivery-form" (input)="removeErrorMessage($event.target)"/>
        </div>
        <div class="user-form-input" [class.invalid]="deliveryForm.get('postNo')!.touched && deliveryForm.get('postNo')!.invalid">
          <label for="postNo" class="user-form-input-label">{{ "INPUTS.ZIP" | translate }} *</label>
          <input id="postNo" type="text" formControlName="postNo" placeholder=" " data-name="delivery-form" (input)="removeErrorMessage($event.target)"/>
        </div>
        <div class="user-form-input" [class.invalid]="deliveryForm.get('phoneNo')!.touched && deliveryForm.get('phoneNo')!.invalid">
          <label for="phoneNo" class="user-form-input-label">{{ "INPUT_FIELDS.PHONE" | translate }} *</label>
          <input id="phoneNo" type="number" formControlName="phoneNo" placeholder=" " data-name="delivery-form" (input)="removeErrorMessage($event.target)"/>
        </div>
        <div class="user-form-input" [class.invalid]="deliveryForm.get('email')!.touched && deliveryForm.get('email')!.invalid">
          <label for="email" class="user-form-input-label">{{ "INPUT_FIELDS.EMAIL_2" | translate }} *</label>
          <input id="email" type="text" formControlName="email" placeholder=" " data-name="delivery-form" (input)="removeErrorMessage($event.target)"/>
        </div>
        <div class="user-form-input" [class.invalid]="deliveryForm.get('country')!.touched && deliveryForm.get('country')!.invalid">
          <label class="user-form-input-label label-dropdown">{{ "INPUTS.COUNTRY" | translate }} *</label>
          <select class="dropdown" formControlName="country" id="delivery-country" (change)="removeCountryErrorMessage()">
            <option *ngFor="let country of countryListCopy" id="{{country.name}}" value="{{country.isoCharCode}}">{{ country.name }}</option>
          </select>
        </div>

        <div class="user-form-input">
          <label for="footnote" class="user-form-input-label">{{ "INPUT_FIELDS.NOTE" | translate }}</label>
          <input id="footnote" type="text" formControlName="footnote" placeholder=" " data-name="delivery-form" (input)="removeErrorMessage($event.target)"/>
        </div>

        <div class="container-checkbox terms-of-sale-container" *ngIf="showConditionTerms">
          <label>
            <input type="checkbox" id="terms-of-sale" (change)="checkValue($event)">
            <span class="checkmark"></span>
            {{ "TERMS_OF_SALE.I_ACCEPT" | translate }}
          </label>
          <a target="_blank" routerLink="/terms-of-sale">{{ "TERMS_OF_SALE.TERMS_OF_SALE" | translate }}</a>
        </div>
      </div>
      <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>

      <div class="container-checkbox terms-of-sale-container" *ngIf="selectedDelivery.id === 'W01' && showConditionTermsW01">
        <label>
          <input type="checkbox" id="terms-of-sale" (change)="checkValue($event)">
          <span class="checkmark"></span>
          {{ "TERMS_OF_SALE.I_ACCEPT" | translate }}
        </label>
        <a target="_blank" routerLink="/terms-of-sale">{{ "TERMS_OF_SALE.TERMS_OF_SALE" | translate }}</a>
      </div>

      <div class="button-container">
        <button class="btn btn-default" type="button" (click)="cancelOrder()">{{ "COMMON.CANCEL" | translate }}</button>
        <button class="btn btn-primary" type="submit" *ngIf="selectedDelivery.id">{{ "COMMON.CONTINUE" | translate }}</button>
      </div>
    </form>
  </div>
</div>